export const FF_ONBOARDING_HAPPY_PATH = 'onboarding-happy-path'
export const FF_ONBOARDING_HAPPY_PATH_PREFERENCES_PAGE =
  'onboarding-happy-path-preferences-page'
export const FF_REFERRAL_PAGE_EXPERIMENT = 'referral-page-experiment'
export const FF_RAFFLE = 'RAFFLE'
export const FF_ONBOARDING_HAPPY_PATH_PREFERENCES_MODAL =
  'ONBOARDING-HAPPY-PATH-PREFERENCES-MODAL'
export const FF_ONBOARDING_SKIP_MODAL = 'ONBOARDING_SKIP_MODAL'
export const FF_MENU_PROMOTIONS = 'PROMOTIONS_IN_MENU'
export const FF_AVALARA_TAXES = 'avalara-taxes'
export const FF_NEW_ORDERS_PAGE = 'new-orders-page'
export const FF_PERSONALIZED_FILTER = 'personalized-filter'
export const FF_NEWNESS_IN_MENU = 'NEWNESS_IN_MENU'
export const FF_RESURRECTION_FUNNEL = 'growth-resurrection-funnel'
export const FF_MENU_SERVICE_MIGRATE_COLLECTIONS =
  'MENU_SERVICE_MIGRATE_COLLECTIONS'
export const FF_MEALS_ALLERGENS = 'meals-service-allergens'
export const FF_REPLACE_IMAGES_WITH_IMGIX =
  'subscription-front-replace-with-imgix'
export const FF_DELETE_ACCOUNT = 'delete-account'
export const FF_FAST_ORDERING = 'FAST_ORDERING'
export const FF_USE_ALLERGENS = 'meals-service-allergens'

export const FF_PAYMENT_METHOD_CAMPAIGN = 'PAYMENT_METHOD_CAMPAIGN'
export const FF_CART_LOADING_BAR = 'CART_LOADING_BAR'
export const FF_PAUSE_PLAN_REMOVE_ONE_WEEK = 'PAUSE_PLAN_REMOVE_ONE_WEEK'
export const FF_PAUSE_DEFLECTION_MODAL = 'PAUSE_DEFLECTION_MODAL'
export const FF_CANCEL_SUBSCRIPTION_INTO_MY_ACCOUNT =
  'CANCEL_SUBSCRIPTION_INTO_MY_ACCOUNT'

export const FF_DISABLE_CANCEL_SUBSCRIPTION_BUTTON =
  'DISABLE_CANCEL_SUBSCRIPTION_BUTTON'

export const FF_MENU_RECIPES = 'MENU_RECIPES'
export const FF_MEAL_DETAIL_VIDEOS = 'MEAL_DETAIL_VIDEOS'
export const FF_CROSS_SELLING_MODAL = 'CROSS_SELLING_MODAL'
export const FF_BANNER_RULES_ENGINE = 'BANNERS-RULES-ENGINE'
export const FF_RESTAURANT_SPECIALS = 'RESTAURANT_SPECIALS'

export const FF_PAUSE_FLOW_ENABLED = 'FF_PAUSE_FLOW_ENABLED'

export const FF_GIFS_IN_MEAL_CARDS = {
  name: 'GIFS_IN_MEAL_CARDS',
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const FF_USE_CHEF_SERVICE = 'use-chef-service'
export const FF_GROWTH_WELCOME_BACK_RESURRECTION_MODAL =
  'GROWTH_WELCOME_BACK_RESURRECTION_MODAL'
export const REDIRECT_REACTIVATED_USER_MENU = 'redirect-reactivated-user-menu'

export const FF_SKU_LINES_TEST = {
  name: 'SKU_LINES_TEST',
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const FF_PAUSE_INFORMATION_MODAL = 'PAUSE_INFORMATION_MODAL'
export const FF_PARTIAL_CART_EXPERIMENT = {
  name: 'PARTIAL_CART_EXPERIMENT',
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const FF_SHOW_REFERRAL_BANNER = 'show_referral_banner'
export const REFERRER_PROMO_SHARE_TRACKER = {
  name: 'referrer_promo_share_component',
  variantsMap: {
    control: 'control',
    treatment: 'treatment'
  }
}

export const FF_USE_NEW_CREDITS_AND_PROMOTIONS_PAGE =
  'USE_NEW_CREDITS_AND_PROMOTIONS_PAGE'

export const FF_USE_FILTERS_REDESIGN_V2 = {
  name: 'USE_FILTERS_REDESIGN_V2',
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const FF_USE_FOR_YOU = {
  name: 'USE-FOR-YOU',
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1',
    treatment2: 'treatment-2'
  }
}

export const FF_FOR_YOU_MODAL = 'for-you-awareness-modal'

export const FF_SKIP_CONFIRMATION_MODAL = 'SKIP_CONFIRMATION_MODAL'

export const FF_ENABLE_BUY_CREDITS_FEATURE = 'ENABLE_BUY_CREDITS_FEATURE'

export const FF_EATER_PROFILE = 'feature-eater-profile'
export const FF_EATER_PROFILE_UI = 'feature-eater-profile-ui'

export const FF_MENU_EARLY_EATERS = {
  name: 'MENU_SERVICE_ponderate_early_eaters',
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}
export const FF_USE_MEALS_LITE = 'USE_MEALS_LITE'

export const FF_OFFER_BANNER_FEATURE = 'OFFER_BANNER_FEATURE'
export const FF_ORDER_STATUS = {
  name: 'ORDER_STATUS',
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const FF_ENABLE_UPDATE_TO_STANDARD_PLAN_FEATURE =
  'ENABLE_UPDATE_TO_STANDARD_PLAN_FEATURE'

export const FF_SHOW_SNACK_CATEGORY = {
  name: 'SHOW_SNACK_CATEGORY',
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}
